import type { Partner } from '@/data'
import api from '..'

export async function getPartner(id: string): Promise<Partner | null> {
  const res = await api.get(`/partners/${id}`)
  return res.data.data
}
